import React, { Fragment, useState } from 'react';
import DropzoneComponent from '../common/DropzoneExample';
import { useDispatch, useSelector } from 'react-redux';
import { uploadUserDocuments, uploadMultipleFilesToS3 } from '../api/fileUploadApi';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const UploadDocuments = (props = {}) => {
    const dispatch = useDispatch();
    const state = useSelector(state => state) || {};
    const uploadDocuments = (e, fn, cb) => dispatch(uploadUserDocuments(e, fn, cb));
    const uploadMultipleDocuments = (e, fn, cb) => dispatch(uploadMultipleFilesToS3(e, fn, cb));

    const { uploadOptions, removeFile, onDrop, onChangeUploadType, uploadType, acceptedFiles = [], rejectedFiles = [], setAcceptedFiles, userFacultyId, isStaffLogin,
        docs = {} } = props;
    const { leaveReducer: { isUploading } = {} } = state;

    const [facultyId, setFacultyId] = useState('');

    const onClickUpload = () => {
        if (!acceptedFiles.length) return;
        const callbacks = {
            successCallback,
            failureCallback,
            facultyId: isStaffLogin ? userFacultyId : facultyId
        };
        const selectedType = uploadOptions.find(op => op.id === uploadType);

        if (selectedType?.isMultiple) {
            const existingFiles = docs[selectedType?.field];
            callbacks.isMultiple = true;
            callbacks.existingFiles = existingFiles;
            uploadMultipleDocuments(acceptedFiles, uploadType, callbacks);
        } else {
            callbacks.isMultiple = false;
            uploadDocuments(acceptedFiles[0], uploadType, callbacks);
        }
    };

    const successCallback = () => {
        setAcceptedFiles([]);
        toast.success("Document uploaded successfully.", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
        });
    }

    const failureCallback = () => toast.error("Unable to upload documents. Please try again....", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
    });

    return (
        <Fragment>
            <div className="card-header upload">
                <h3 className="card-title">Upload Documents</h3>
            </div>
            <div className="upload-section">
                <DropzoneComponent
                    maxFiles={uploadType === "profilePhoto" ? 1 : 8}
                    disable={uploadType === "select"}
                    onDrop={onDrop}
                    accept={
                        uploadType === "profilePhoto" ? "image/*" : ".pdf, image/*"
                    }
                    uploadType={uploadType}
                    rejectedFiles={rejectedFiles}
                    acceptedFiles={acceptedFiles}
                    removeFile={removeFile}
                    isUploading={isUploading}
                />
                <div className="form-wrapper">
                    <div className="col-md-6 col-sm-12">
                        <div className="form-group upload">
                            <label>Enter Faculty Id</label>
                            <input
                                className='form-control big'
                                type="text"
                                value={isStaffLogin ? userFacultyId : facultyId}
                                onChange={(e) => setFacultyId(e.target.value)}
                                disabled={isStaffLogin} />
                            <label>Select File Type</label>
                            <select name="uploadType" className="form-control big" onChange={(e) => onChangeUploadType(e.target.value)}>
                                <option value="select">Select</option>
                                {uploadOptions.map((option, id) => {
                                    return <option key={`${id}_${option.id}`} value={option.id}>{option.value}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div
                        className="col-md-12"
                        style={{ display: "flex" }}
                    >
                        <button className="btn btn-outline-secondary upload-btn" onClick={() => setAcceptedFiles([])}>
                            Reset
                        </button>
                    </div>
                    <div className="col-md-12">
                        <button
                            type="submit"
                            className="mr-1 btn btn-primary upload-btn mt-4"
                            onClick={onClickUpload}
                            disabled={isUploading}
                        >
                            {isUploading ? 'Uploading...' : 'Upload'}
                        </button>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </Fragment>
    );
}

export default UploadDocuments;